import React from 'react';
import { Ad, Header } from './components/Ad';
import { AdLister } from './styles';

export default class AdList extends React.Component {

  render = () => {
    if (this.props.ads.length === 0) { return null; }
    const sortedAds = this.sortByPriceDiff(this.props.ads);
    const adRows = sortedAds.map((ad, index) => <Ad key={index} ad={ad} phoneNumber={this.props.phoneNumber}/>);
    return (
      <AdLister>
        <Header/>
        {adRows}
      </AdLister>
    );
  }

  sortByPriceDiff = (ads) => ads.sort((a, b) => b.priceDiff - a.priceDiff);

}



// WEBPACK FOOTER //
// ./src/components/AdList/index.js